(function ($, window, document) {
    'use strict';

    var root = document.documentElement;

    function initThemeAnimations() {
        var gsap = window.gsap;
        var ScrollTrigger = window.ScrollTrigger;
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var claimed = new WeakSet();

        if (!gsap || !ScrollTrigger || reducedMotion || document.body.classList.contains('wp-admin')) {
            root.classList.remove('gsap-preload');
            root.classList.add('gsap-ready');
            return;
        }

        gsap.registerPlugin(ScrollTrigger);
        gsap.defaults({ duration: 1, ease: 'power3.out' });
        gsap.config({ force3D: true, nullTargetWarn: false });
        ScrollTrigger.config({ limitCallbacks: true });
        root.classList.add('gsap-ready');

        function allowed(element) {
            return element && !claimed.has(element) &&
                !element.closest('.site-header, .site-footer, [data-no-gsap]');
        }

        function getItems(elements) {
            return gsap.utils.toArray(elements).filter(allowed);
        }

        function claim(elements) {
            elements.forEach(function (element) { claimed.add(element); });
        }

        function scrollReveal(elements, options) {
            var settings = options || {};
            var items = getItems(elements);
            var initialState;

            if (!items.length) {
                return null;
            }

            claim(items);
            initialState = {
                autoAlpha: 0,
                x: settings.x || 0,
                y: settings.y === undefined ? 34 : settings.y,
                scale: settings.scale === undefined ? 1 : settings.scale,
                rotate: settings.rotate || 0
            };
            gsap.set(items, initialState);

            return gsap.to(items, {
                autoAlpha: 1,
                x: 0,
                y: 0,
                scale: 1,
                rotate: 0,
                duration: settings.duration || 1,
                stagger: settings.stagger === undefined ? 0.075 : settings.stagger,
                ease: settings.ease || 'power3.out',
                clearProps: 'opacity,visibility,transform,willChange',
                willChange: 'transform,opacity',
                scrollTrigger: {
                    trigger: settings.trigger || items[0],
                    start: settings.start || 'top 90%',
                    toggleActions: 'play none none reverse',
                    invalidateOnRefresh: true
                }
            });
        }

        function heroTimeline(container) {
            var content = container && container.querySelector('.page-hero-content, .referenz-hero-content');
            var items = content ? Array.prototype.filter.call(content.children, allowed) : [];
            var eyebrow;
            var title;
            var supporting;
            var timeline;

            if (!items.length) {
                return;
            }

            claim(items);
            gsap.killTweensOf(items);
            eyebrow = content.querySelector('.main-subtitle, .line-subtitle');
            title = content.querySelector('h1, .main-title');
            supporting = items.filter(function (item) {
                return item !== eyebrow && item !== title;
            });
            timeline = gsap.timeline({ defaults: { ease: 'power4.out' }, delay: 0.08 });

            if (eyebrow) {
                timeline.fromTo(eyebrow, { autoAlpha: 0, x: -22 }, {
                    autoAlpha: 1,
                    x: 0,
                    immediateRender: true,
                    duration: 0.8,
                    clearProps: 'opacity,visibility,transform'
                });
            }

            if (title) {
                timeline.fromTo(title, { autoAlpha: 0, y: 46, skewY: 1.5 }, {
                    autoAlpha: 1,
                    y: 0,
                    skewY: 0,
                    immediateRender: true,
                    duration: 1.15,
                    clearProps: 'opacity,visibility,transform'
                }, eyebrow ? '-=0.48' : 0);
            }

            if (supporting.length) {
                timeline.fromTo(supporting, { autoAlpha: 0, y: 22 }, {
                    autoAlpha: 1,
                    y: 0,
                    immediateRender: true,
                    duration: 0.85,
                    stagger: 0.08,
                    clearProps: 'opacity,visibility,transform'
                }, '-=0.72');
            }
        }

        function initHeroes() {
            var pageHero = document.querySelector('#header-image');
            var referenzHero = document.querySelector('.referenz-hero');

            if (pageHero) {
                heroTimeline(pageHero.querySelector('.carousel-item.active') || pageHero);
                $(pageHero).on('slid.bs.carousel', function (event) {
                    heroTimeline(event.relatedTarget || pageHero.querySelector('.carousel-item.active'));
                });
            }

            if (referenzHero) {
                var heroMedia = referenzHero.querySelector('.referenz-hero-media');
                var heroImage = heroMedia && heroMedia.querySelector('img');
                heroTimeline(referenzHero);

                if (heroImage) {
                    gsap.fromTo(heroImage, { scale: 1.09 }, {
                        scale: 1,
                        duration: 1.9,
                        ease: 'power2.out',
                        clearProps: 'transform,willChange',
                        willChange: 'transform'
                    });
                }
            }
        }

        function initSectionHeaders() {
            var selectors = [
                'main .section-header',
                'main .meilensteine-header',
                'main .karriere-jobs-header',
                'main .referenzen-header',
                'main .referenz-process-header',
                'main .anfragen-flow-header'
            ];

            document.querySelectorAll(selectors.join(',')).forEach(function (header) {
                var children = getItems(Array.prototype.filter.call(header.children, function (child) {
                    return !child.matches('script, style, [hidden]');
                }));
                var eyebrow;
                var rest;
                var timeline;

                if (!children.length) {
                    return;
                }

                claim(children);
                eyebrow = header.querySelector('.main-subtitle, .line-subtitle');
                rest = children.filter(function (child) { return child !== eyebrow; });
                timeline = gsap.timeline({
                    scrollTrigger: {
                        trigger: header,
                        start: 'top 90%',
                        toggleActions: 'play none none reverse'
                    }
                });

                if (eyebrow && children.indexOf(eyebrow) !== -1) {
                    timeline.fromTo(eyebrow, { autoAlpha: 0, x: -18 }, {
                        autoAlpha: 1,
                        x: 0,
                        immediateRender: true,
                        duration: 0.72,
                        ease: 'power3.out',
                        clearProps: 'opacity,visibility,transform'
                    });
                }

                if (rest.length) {
                    timeline.fromTo(rest, { autoAlpha: 0, y: 28 }, {
                        autoAlpha: 1,
                        y: 0,
                        immediateRender: true,
                        duration: 0.95,
                        stagger: 0.08,
                        ease: 'power4.out',
                        clearProps: 'opacity,visibility,transform'
                    }, eyebrow ? '-=0.38' : 0);
                }
            });
        }

        function initCollections() {
            var groups = [
                ['.referenzen-track', 42, 0.09],
                ['.referenzen-grid', 42, 0.08],
                ['.team-grid', 40, 0.07],
                ['.karriere-jobs-list', 24, 0.065],
                ['.meilensteine-track', 30, 0.11],
                ['.counter-numbers', 24, 0.1],
                ['.logos-list', 24, 0.055],
                ['.grid-cards', 34, 0.07],
                ['.taxonomy-posts-grid', 36, 0.075],
                ['.taxonomy-posts-slider', 36, 0.075],
                ['.block-cpt-grid', 36, 0.075],
                ['.block-cpt-slider', 36, 0.075],
                ['.referenz-process-grid', 26, 0.11],
                ['.referenz-gallery', 30, 0.09],
                ['.anfragen-options', 24, 0.055],
                ['.contact-details-list', 20, 0.07]
            ];

            groups.forEach(function (settings) {
                document.querySelectorAll(settings[0]).forEach(function (group) {
                    scrollReveal(Array.prototype.filter.call(group.children, function (child) {
                        return !child.matches('script, style, [hidden]');
                    }), {
                        trigger: group,
                        y: settings[1],
                        scale: 0.992,
                        stagger: settings[2],
                        duration: 0.95,
                        start: 'top 91%'
                    });
                });
            });
        }

        function initFlexibleBlocks() {
            document.querySelectorAll('.block_referenzen .referenzen').forEach(function (block) {
                var heading = block.querySelector('.referenzen-heading');
                var navigation = block.querySelector('.referenzen-nav');
                var filters = block.querySelector('.referenzen-filters');
                var archive = block.querySelector('.referenzen-archive');

                if (heading) {
                    scrollReveal(heading.children, {
                        trigger: heading,
                        y: 28,
                        stagger: 0.1,
                        duration: 0.95,
                        ease: 'power4.out'
                    });
                }

                scrollReveal([navigation, filters, archive].filter(Boolean), {
                    trigger: block,
                    y: 18,
                    stagger: 0.08,
                    duration: 0.8,
                    start: 'top 90%'
                });
            });

            document.querySelectorAll('.block_quality_trust .quality-trust').forEach(function (block) {
                var header = block.querySelector('.quality-trust-header');
                var copy = block.querySelector('.quality-trust-copy');
                var stats = block.querySelector('.quality-trust-stats');
                var testimonialsLabel = block.querySelector('.quality-trust-testimonials-label');
                var testimonialsGrid = block.querySelector('.quality-trust-testimonials-grid');

                if (header) {
                    scrollReveal(header.children, {
                        trigger: header,
                        y: 30,
                        stagger: 0.11,
                        duration: 1,
                        ease: 'power4.out'
                    });
                }

                if (copy) {
                    scrollReveal(copy.children, {
                        trigger: copy,
                        x: -28,
                        y: 16,
                        stagger: 0.1,
                        duration: 0.95
                    });
                }

                if (stats) {
                    scrollReveal(stats.children, {
                        trigger: stats,
                        x: 28,
                        y: 18,
                        scale: 0.985,
                        stagger: 0.1,
                        duration: 1
                    });
                }

                scrollReveal([testimonialsLabel].filter(Boolean), {
                    trigger: testimonialsLabel,
                    x: -18,
                    y: 0,
                    duration: 0.75
                });

                if (testimonialsGrid) {
                    scrollReveal(testimonialsGrid.children, {
                        trigger: testimonialsGrid,
                        y: 26,
                        stagger: 0.1,
                        duration: 0.9
                    });
                }
            });

            document.querySelectorAll('.block_text_accordion .text-accordion-row').forEach(function (row) {
                var content = row.querySelector('.text-accordion-content');
                var accordion = row.querySelector('.text-accordion');

                if (content) {
                    scrollReveal(content.children, {
                        trigger: row,
                        x: -30,
                        y: 14,
                        stagger: 0.075,
                        duration: 0.95
                    });
                }

                if (accordion) {
                    scrollReveal(accordion.querySelectorAll('.text-accordion-item'), {
                        trigger: row,
                        x: 28,
                        y: 12,
                        stagger: 0.075,
                        duration: 0.9
                    });
                }
            });

            document.querySelectorAll('.block_master_text .master-text-content').forEach(function (content) {
                scrollReveal(content.children, {
                    trigger: content,
                    y: 26,
                    stagger: 0.075,
                    duration: 0.95
                });
            });

            document.querySelectorAll('.block_buttons .dd-buttons, .block_master_text .dd-buttons').forEach(function (buttons) {
                scrollReveal(buttons.children, {
                    trigger: buttons,
                    y: 18,
                    stagger: 0.07,
                    duration: 0.75
                });
            });

            document.querySelectorAll('.block_accordion_or_tabs .accordion-tabs').forEach(function (block) {
                var navigation = block.querySelector('.accordion-tabs-nav');
                var tabContent = block.querySelector('.accordion-tabs-content');
                var accordion = block.querySelector('.accordion-tabs-accordion');

                if (navigation) {
                    scrollReveal(navigation.children, {
                        trigger: block,
                        y: 18,
                        stagger: 0.07,
                        duration: 0.75
                    });
                }

                scrollReveal([tabContent].filter(Boolean), {
                    trigger: block,
                    y: 24,
                    duration: 0.9
                });

                if (accordion) {
                    scrollReveal(accordion.children, {
                        trigger: block,
                        y: 18,
                        stagger: 0.075,
                        duration: 0.85
                    });
                }
            });

            document.querySelectorAll('.block_tables .tables-block').forEach(function (block) {
                scrollReveal(block.querySelectorAll('.tables-group'), {
                    trigger: block,
                    y: 28,
                    stagger: 0.1,
                    duration: 0.95
                });
            });

            document.querySelectorAll('.block_cpt .block-cpt-taxonomy-heading, .block_taxonomy_posts .taxonomy-posts-group-header').forEach(function (header) {
                scrollReveal(header.children, {
                    trigger: header,
                    y: 20,
                    stagger: 0.07,
                    duration: 0.82
                });
            });
        }

        function initEditorialBlocks() {
            document.querySelectorAll('.block_text_image .row, .block_bg_with_text .row').forEach(function (row) {
                var columns = getItems(row.children);

                if (!columns.length) {
                    return;
                }

                claim(columns);
                columns.forEach(function (column, index) {
                    gsap.fromTo(column, {
                        autoAlpha: 0,
                        x: index % 2 === 0 ? -34 : 34,
                        y: 16
                    }, {
                        autoAlpha: 1,
                        x: 0,
                        y: 0,
                        immediateRender: true,
                        duration: 1.1,
                        ease: 'power3.out',
                        clearProps: 'opacity,visibility,transform,willChange',
                        willChange: 'transform,opacity',
                        scrollTrigger: {
                            trigger: row,
                            start: 'top 89%',
                            toggleActions: 'play none none reverse'
                        }
                    });
                });
            });

            document.querySelectorAll('.block_columns .row').forEach(function (row) {
                scrollReveal(row.children, {
                    trigger: row,
                    y: 30,
                    stagger: 0.1,
                    duration: 1
                });
            });

            document.querySelectorAll('.entry-content, .page-content').forEach(function (content) {
                var children = Array.prototype.filter.call(content.children, function (child) {
                    return !child.matches('section, script, style, [hidden]');
                });
                scrollReveal(children, {
                    trigger: content,
                    y: 26,
                    stagger: 0.07,
                    duration: 0.9
                });
            });
        }

        function initGewerke() {
            document.querySelectorAll('.block_gewerke .gewerke').forEach(function (block) {
                scrollReveal(block.querySelectorAll('.gewerke-bar > *'), {
                    trigger: block,
                    x: -16,
                    y: 0,
                    stagger: 0.08,
                    duration: 0.8
                });
                scrollReveal(block.querySelectorAll('.gewerke-slide.is-active .gewerke-circle'), {
                    trigger: block,
                    y: 16,
                    scale: 0.94,
                    duration: 1.15,
                    ease: 'power4.out'
                });
                scrollReveal(block.querySelectorAll('.gewerke-slide.is-active .gewerke-media'), {
                    trigger: block,
                    x: 42,
                    y: 0,
                    duration: 1.15,
                    ease: 'power4.out'
                });
            });
        }

        function initFormsAndFacts() {
            scrollReveal(document.querySelectorAll('.contact-details > .contact-eyebrow'), {
                y: 0,
                x: -18,
                duration: 0.75
            });

            document.querySelectorAll('.contact-form-panel .wpcf7-form, .career-application-form').forEach(function (form) {
                scrollReveal(form.querySelectorAll('.contact-form-topic, .contact-form-field, .career-form-topic, .career-form-field, .career-form-privacy, .wpcf7-submit'), {
                    trigger: form,
                    y: 16,
                    stagger: 0.045,
                    duration: 0.72,
                    start: 'top 91%'
                });
            });

            document.querySelectorAll('.referenz-facts-grid, .referenz-task-grid, .referenz-project-navigation-inner').forEach(function (group) {
                scrollReveal(group.children, {
                    trigger: group,
                    y: 24,
                    stagger: 0.085,
                    duration: 0.9
                });
            });
        }

        function initImageReveals() {
            var selectors = [
                '.block_images figure',
                '.block-gallery .gallery-lightbox-item',
                '.referenz-gallery-item',
                '.referenzen-grid-image'
            ];

            document.querySelectorAll(selectors.join(',')).forEach(function (media) {
                var image;

                if (!allowed(media)) {
                    return;
                }

                claimed.add(media);
                image = media.querySelector('img');
                gsap.fromTo(media, { autoAlpha: 0, clipPath: 'inset(0 0 14% 0)' }, {
                    autoAlpha: 1,
                    clipPath: 'inset(0 0 0% 0)',
                    immediateRender: true,
                    duration: 1.05,
                    ease: 'power3.out',
                    clearProps: 'opacity,visibility,clipPath,willChange',
                    willChange: 'opacity,clip-path',
                    scrollTrigger: {
                        trigger: media,
                        start: 'top 92%',
                        toggleActions: 'play none none reverse'
                    }
                });

                if (image) {
                    gsap.fromTo(image, { scale: 1.055 }, {
                        scale: 1,
                        duration: 1.25,
                        ease: 'power2.out',
                        clearProps: 'transform,willChange',
                        willChange: 'transform',
                        scrollTrigger: {
                            trigger: media,
                            start: 'top 92%',
                            toggleActions: 'play none none reverse'
                        }
                    });
                }
            });
        }

        function initParallax() {
            var mm = gsap.matchMedia();

            mm.add('(min-width: 992px) and (prefers-reduced-motion: no-preference)', function () {
                document.querySelectorAll('.referenz-gallery-item img, .block_text_image img, .gewerke-image-primary img').forEach(function (image) {
                    if (image.closest('[data-no-gsap]')) {
                        return;
                    }

                    gsap.fromTo(image, { yPercent: -2.5 }, {
                        yPercent: 2.5,
                        ease: 'none',
                        scrollTrigger: {
                            trigger: image.parentElement,
                            start: 'top bottom',
                            end: 'bottom top',
                            scrub: 1.6,
                            invalidateOnRefresh: true
                        }
                    });
                });
            });
        }

        initHeroes();
        initSectionHeaders();
        initFlexibleBlocks();
        initCollections();
        initEditorialBlocks();
        initGewerke();
        initFormsAndFacts();
        initImageReveals();
        initParallax();

        root.classList.remove('gsap-preload');

        window.addEventListener('load', function () {
            ScrollTrigger.refresh();
        }, { once: true });

        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(function () { ScrollTrigger.refresh(); });
        }
    }

    initThemeAnimations();
})(jQuery, window, document);
